// extracted by mini-css-extract-plugin
export default {"arrow":"K03GOd","arrowOpen":"wziyDp"};